import { Grid, Typography } from '@material-ui/core'
import React from 'react'
import InfoIcon from '@material-ui/icons/Info';
import { formatDate } from '../../../common/formatDate';


export const ReportComments = ({ comments, text ,version }: any) => {
    if (!comments || comments.length === 0) {
        return null;
    }
    return (

        <>
            {comments.map((comment: any, index: number) => (
                <React.Fragment key={comment.id || index}>
                    <Grid container alignItems="center" spacing={1}>
                        <Grid item xs={10}>
                            <InfoIcon fontSize="small" style={{ marginRight: "10px" }} />
                            <Typography variant="body2" display="inline">
                                <i>{`${comment.comment} by ${comment.user_name} at ${formatDate(comment.datetime)}`}</i>
                            </Typography>
                        </Grid>

                    </Grid>
                </React.Fragment>
            ))}
        </>

    )
}


